module.exports = function (settingsService) {
    return {
        restrict: 'A',
        compile(element, attrs) {
            settingsService.getSettingValue(attrs.settingGroup, attrs.settingName).then(function (value) {
                element.html(value);
            });
        }
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/settings/settings-html-directive.js
 **/